import mixins from 'vue-typed-mixins'
import routeMixin from '@/router/routeMixin'
import PasswordModel from './models/passwordModel'

export default mixins(routeMixin).extend({
    methods: {
        init(model: PasswordModel) {
            model.email = this.query('email')
        },
        validate(model: PasswordModel) {
            model.code = this.query('code')
            this.$http
                .api('account/register-confirm', true)
                .post(model)
                .then(() => {
                    this.$swal.toast.success()
                    this.navigateToLogin()
                })
                .catch(x => this.$swal.toast.errorApi(x))
        }
    }
})
